export const selectedJobTitlesAsOptions = selectedJobTitles => {
    if (selectedJobTitles.length > 0)
        return selectedJobTitles.map(selectedJobTitle => ({
            value: selectedJobTitle.id,
            label: selectedJobTitle.title,
            color: selectedJobTitle.color,
        }));
    return [];
};